import { LightningElement, api } from "lwc";

export default class PrimitiveNav extends LightningElement {}
